import { injectable } from 'tsyringe'
import { FAQApiRepository } from '@/app/repositories/api/FAQApiRepository'
import { FAQ } from '@/domain/entities/Faq'
import {
  PostFAQInterface,
  DeleteFAQInterface,
  UpdateFAQInterface,
} from '@/data/payload/contracts/FAQRequest'
@injectable()
export class FAQPresenter {
  private repository: FAQApiRepository

  constructor(repository: FAQApiRepository) {
    this.repository = repository
  }

  public loadFAQ(params: Object): Promise<FAQ> {
    return this.repository.getAll(params)
  }

  public postFAQ(payload: PostFAQInterface): Promise<FAQ> {
    return this.repository.post(payload)
  }

  public updateFAQ(payload: UpdateFAQInterface, id: number): Promise<FAQ> {
    return this.repository.update(payload, id)
  }

  public deleteFAQ(payload: DeleteFAQInterface): Promise<FAQ> {
    return this.repository.delete(payload)
  }
}
